import api from "./Api";

class CategoriaPedidoService {
  GetCategoriaPedido(payload) {
    return api.get("/v1/categoriaPedido/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCategoriaPedido(payload) {
    return api.post("/v1/categoriaPedido/", payload).then((response) => {
      return response.data;
    });
  }

  PutCategoriaPedido(payload) {
    return api.put("/v1/categoriaPedido/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCategoriaPedido(payload) {
    return api.delete("/v1/categoriaPedido/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCategoriaPedidoOData(payload) {
    return api.get("/OData/CategoriaPedido" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CategoriaPedidoService();
